import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ButtonModule, NavigatorModule, TooltipModule as XrefTooltipModule} from '@xref/xref-lib';
import { ReferenceReportContentModule } from "../../components/reference-report-content/reference-report-content.module";
import { ReferenceReportComponent } from "./reference-report.component";
import {LoaderModule} from "../../components/loader/loader.module";
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TooltipEllipsifyModule } from 'src/app/directives/tooltip-ellipsify/tooltip-ellipsify.module';
import { ActiveLinkDirective } from './active-link.directive';

@NgModule({
  declarations: [ReferenceReportComponent, ActiveLinkDirective],
  imports: [
    CommonModule,
    ReferenceReportContentModule,
    LoaderModule,
    ButtonModule,
    XrefTooltipModule,
    TooltipModule.forRoot(),
    TooltipEllipsifyModule,
    NavigatorModule
  ],
  exports: [
    ReferenceReportComponent
  ]
})
export class ReferenceReportModule { }
